var TEN_YEARS_IN_SECONDS, setSiteCookies;

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

module.exports = setSiteCookies = function(cookies, seconds) {
  var cookieDomain, key, results, val;
  if (seconds == null) {
    seconds = TEN_YEARS_IN_SECONDS;
  }
  cookieDomain = setSiteCookies.cookieDomain || (setSiteCookies.cookieDomain = $('head').data('domain'));
  results = [];
  for (key in cookies) {
    val = cookies[key];
    if (val != null) {
      results.push(Cookie.set(key, val, seconds, cookieDomain));
    } else {
      results.push(Cookie.unset(key, cookieDomain));
    }
  }
  return results;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9zZXRTaXRlQ29va2llcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3NldFNpdGVDb29raWVzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLG9CQUFBLEdBQXVCLEVBQUEsR0FBSyxFQUFMLEdBQVUsRUFBVixHQUFlLEdBQWYsR0FBcUI7O0FBRzVDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGNBQUEsR0FBaUIsU0FBQyxPQUFELEVBQVUsT0FBVjtBQUNoQyxNQUFBOztJQUQwQyxVQUFVOztFQUNwRCxZQUFBLEdBQWUsY0FBYyxDQUFDLGlCQUFmLGNBQWMsQ0FBQyxlQUFpQixDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsSUFBVixDQUFlLFFBQWY7QUFDL0M7T0FBQSxjQUFBOztJQUNFLElBQUcsV0FBSDttQkFDRSxNQUFNLENBQUMsR0FBUCxDQUFXLEdBQVgsRUFBZ0IsR0FBaEIsRUFBcUIsT0FBckIsRUFBOEIsWUFBOUIsR0FERjtLQUFBLE1BQUE7bUJBR0UsTUFBTSxDQUFDLEtBQVAsQ0FBYSxHQUFiLEVBQWtCLFlBQWxCLEdBSEY7O0FBREY7O0FBRmdDIn0=
